import React from 'react';
import { Product } from 'core/types/api/Api';
import arrayContains from 'utils/arrayUtils';
import { ProductOfferSelection } from '../product-offer-selection';
import { PRODUCTS, EXTERNAL_PRODUCTS } from '../../constants/constants';

import './product-offers-selection.css';

type ProductOffersSelectionType = {
    productOffers: Array<Product>,
    onSelectedProductOfferChange: (value: number) => void,
    selectProductOfferId: number,
    isFzAndFzpAlreadyApplied: boolean
}

const sortProductOffers = (productOffers: Array<Product>, sortPriority: string[]) => productOffers.sort((a, b) => {
    const indexA = sortPriority.indexOf((a.externalId ?? '').trim().toLowerCase());
    const indexB = sortPriority.indexOf((b.externalId ?? '').trim().toLowerCase());

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;

    return ((a.externalId ?? '').trim().toLowerCase()).localeCompare((b.externalId ?? '').trim().toLowerCase());
});

export const ProductOffersSelection = ({
    productOffers,
    onSelectedProductOfferChange,
    selectProductOfferId,
    isFzAndFzpAlreadyApplied,
}: ProductOffersSelectionType) => {
    const priority = [EXTERNAL_PRODUCTS.aaa, EXTERNAL_PRODUCTS.aaap, EXTERNAL_PRODUCTS.fz, EXTERNAL_PRODUCTS.fzp];
    const productOffersByPriority = sortProductOffers(productOffers, priority);

    return (
        <div className="fi-products-selection">
            {productOffersByPriority.map(productOffer => (
                <ProductOfferSelection
                    key={productOffer.id}
                    disabled={!productOffer.isEnabled || (isFzAndFzpAlreadyApplied && arrayContains([PRODUCTS.fzp, PRODUCTS.fz], productOffer?.settings?.productKey))}
                    productOffer={productOffer}
                    isSelected={selectProductOfferId === productOffer.id}
                    onSelectionChange={onSelectedProductOfferChange}
                />
            ))}
        </div>
    );
};
